<form name="textEditorForm" class="bc-editor-form clearfix" [ngClass]="{ 'editor-disabled': editorDisabled }">
  <div class="full-scale">
    <div class="bc-editor">
      <div *ngIf="isCommandListVisible"
           #scrollParentElement
           class="bc-command-list bc-panel"
           [attr.data-automation-id]="'bc-command-list'">
        <virtual-scroller *ngIf="allFilteredCommandList.length" [items]="allFilteredCommandList" [bufferAmount]="4"
                          #commandListVirtualScroller [parentScroll]="scrollParentElement"
                        (vsUpdate)="commandListVirtualListUpdated($event)" class="command-list-virtual-scroll">
          <div *ngFor="let command of commandListVirtualScroller.viewPortItems"
               class="bc-command-list-item"
               (click)="commandClicked(command)"
               (mouseenter)="setSelectedCommandIndex(getCommandIndex(command))"
               [ngClass]="{'selected': getCommandIndex(command) === selectedCommandIndex, 'bc-command-list-header': command.header}"
               [attr.data-automation-id]="'bc-command-list-item'">
            <span *ngIf="command.header"
                  translate [translateParams]="{ searchFilter: getEditorTextTillFirstSpace() }">
              {{ getEditorText()==='/' ? command.defaultText : command.filteredText }}
            </span>
            <span *ngIf="!command.header" class="bc-command-shortcut">{{ command.shortcut }}</span>
            <span *ngIf="!command.header && !command.cannedMessage" class="bc-command-description">{{command.description | translate}}</span>
            <span *ngIf="!command.header && command.cannedMessage" class="bc-command-description" [innerHTML]="command.description"></span>
          </div>
        </virtual-scroller>
      </div>

      <div *ngIf="showInsertImageDialog" class="image-insert-dialog">
        <form #imageForm>
          <input #insertImageInput
                 type="url"
                 required="required"
                 name="src"
                 placeholder="{{ 'bcEditor.insertImageLinkPlaceholder' | translate }}"
                 [(ngModel)]="imageLink"
                 [ngClass]="{ 'validate': imageLinkInvalid }"
                 (keydown)="insertImageLink($event)">
          <input type="button" value="{{ 'bcEditor.insertImage' | translate }}" (click)="insertImageLink($event)">
        </form>
      </div>

      <div *ngIf="showPushLinkDialog" class="push-link-dialog">
        <form #pushLinkForm="ngForm">
          <input #pushLinkInput
                 type="text"
                 required
                 name="pushLinkValue"
                 placeholder="{{ 'bcEditor.toolbar.linkUrlPlaceholder' | translate }}"
                 [(ngModel)]="pushLink"
                 (keydown)="onPushLinkKeyDown($event, pushLinkForm)"
                 [ngClass]="{ 'validate': !pushLinkForm.form.valid }"
                 [attr.data-automation-id]="'bc-editor-push-link-placeholder'">
          <input [disabled]="!pushLinkForm.form.valid"
                 type="button"
                 value="{{ 'bcEditor.toolbar.pushLink' | translate }}"
                 (click)="insertPushLink(pushLinkForm)"
                 [attr.data-automation-id]="'bc-editor-push-link'">
        </form>
      </div>

      <div class="bc-editor-text-container">
        <app-file-upload-picker *ngIf="showFileUpload"
                                class="file-upload-picker-handler"
                                [editorMessages]="editorMessages"
                                [workItemId]="workItemId"
                                [workItemType]="workItemType"></app-file-upload-picker>
        <editor class="{{getAccessibilityClass()}}"
                #tinyMceEditor
                [ngModel]="editorContentModel"
                (ngModelChange)="handleInnerChange($event)"
                name="tinyMceEditor"
                [attr.data-automation-id]="'bc-editor-instance'"></editor>
        <button type="button"
                class="btn js-quote-button quote-button"
                title="{{ 'bcEditor.quoteButtonTooltip' | translate }}"
                *ngIf="showQuoteButton"
                (click)="onQuoteButtonClick()"
                [attr.data-automation-id]="'bc-editor-quote-button'">
          ...
        </button>
      </div>
    </div>
  </div>
</form>
